import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Injectable} from '@angular/core';
import {ErrorModal} from "../../modals/error-modal/error-modal.component";
import {ConfirmModal} from '../../modals/confirm-modal/confirm-modal.component';
import {SuccessModal} from "../../modals/success-modal/success-modal.component";
import {ToastrService} from "ngx-toastr";

@Injectable({
    providedIn: 'root'
})

export class MessagesService {

    constructor(
        private toastr: ToastrService,
        private modalService: NgbModal
    ) {
    }

    overwriteMediaModal(content: string = 'The file already exists, do you want to overwrite?', title: string = 'Overwrite Media', buttonText: string = 'Confirm') {
        const modalRef = this.modalService.open(ConfirmModal);

        if (title)      modalRef.componentInstance.title = title;
        if (content)    modalRef.componentInstance.content = content;
        if (buttonText) modalRef.componentInstance.buttonText = buttonText;

        return modalRef;
    }

    confirmModal(content: string = 'Are you sure? This action cannot be undone.', title: string = 'Confirm!', buttonText: string = 'Confirm') {
        const modalRef = this.modalService.open(ConfirmModal);

        if (title)      modalRef.componentInstance.title = title;
        if (content)    modalRef.componentInstance.content = content;
        if (buttonText) modalRef.componentInstance.buttonText = buttonText;

        return modalRef;
    }

    successModal(content:string = null, title:string = 'Done!', buttonText:string = null) {
        const modalRef = this.modalService.open(SuccessModal);

        if (title)      modalRef.componentInstance.title = title;
        if (content)    modalRef.componentInstance.content = content;
        if (buttonText) modalRef.componentInstance.buttonText = buttonText;

        return modalRef;
    }

    errorModal(content:string = null, title:string = 'Error!', buttonText:string = null) {
        const modalRef = this.modalService.open(ErrorModal);

        if (title)      modalRef.componentInstance.title = title;
        if (content)    modalRef.componentInstance.content = content;
        if (buttonText) modalRef.componentInstance.buttonText = buttonText;

        return modalRef;
    }

    errorToast(content: any, title:string = 'Error!') {
        // todo: parse error
        let error = content;

        if (typeof error['error'] !== 'undefined') {
            error = error.error;
            if (typeof error['error'] !== 'undefined')
                error = error.error;
        }

        return this.toastr.error(error, title);
    }

    successToast(content: string, title:string = 'Done!') {
        return this.toastr.success(content, title);
    }
}
